export enum ThreePLTrainApprovalStatusType {
  Approved = 'Approved',
  Refused = 'Refused',
  Started = 'Started'
}
